import DesignateContacts from './DesignateContacts';
export { DesignateContacts };
export default DesignateContacts;
